import React, { useEffect, useContext, useCallback, useState, useRef } from "react";
import AppContext from "../../store/app-context";
import Button from "../UI/Button";
import { SetAnalyticsData } from '../../util/SetAnalyticsData';
import { HelpCircle, Download } from "react-feather";

import styles from "./QuoteDetailsHeaderNewBrand.module.css";

const QuoteDetailsHeaderNewBrand = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAPIError, setIsAPIError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('Error fetching data...');
  
  const appCtx = useContext(AppContext);
  const [expanded, setExpanded] = useState(false);
  const [shouldShowSeeMore, setShouldShowSeeMore] = useState(false);
  const commentRef = useRef(null);
  
  const quote = props.quote;

  useEffect(() => {
    if (commentRef.current) {
      const lineHeight = parseInt(getComputedStyle(commentRef.current).lineHeight);
      const totalHeight = commentRef.current.scrollHeight;
      const lines = totalHeight / lineHeight;
      setShouldShowSeeMore(lines > 2);
    }
  }, [quote?.comments]);

  let label_quoteId = 'Quote ID ';
  let label_WebRef = 'Web reference ID ';
  let label_downloadPDF = 'Download PDF';
  let label_contactInfo = 'Contact support';
  let label_createdOn = 'Created on';
  let label_neededBy = 'Needed by';
  let label_status = 'Status';
  let label_comments = 'Comments';
  let label_acctNo = 'Account number';
  let label_pPlan = 'Purchase plan';
  let label_email = 'Email address';
  let label_purposeOfQuote = 'Purpose of quote';
  let label_grantApp = 'Grant application';
  let label_newLab = 'New lab';
  let label_salesRep = 'Sales representative';
  let label_pp_immediately="Immediately";
  let label_pp_1_3_months="1 to 3 months";
  let label_pp_6_months="6 months";
  let label_pp_more_than_6_months="More than 6 months";
  let label_fetch_error = 'Sorry, we are experiencing issues. Please try again later.';
  let label_seeMore = 'See more';

  if(appCtx && appCtx.bioradResources){
    label_quoteId = appCtx.bioradResources.QuoteId ? appCtx.bioradResources.QuoteId : 'Quote ID ';
    label_WebRef = appCtx.bioradResources.WebReferenceID ? appCtx.bioradResources.WebReferenceID : 'Web reference ID ';
    label_downloadPDF = appCtx.bioradResources.Download_PDF ? appCtx.bioradResources.Download_PDF : 'Download PDF';
    label_contactInfo = appCtx.bioradResources.Contact_Info ? appCtx.bioradResources.Contact_Info : 'Contact support';
    label_createdOn = appCtx.bioradResources.Created_On ? appCtx.bioradResources.Created_On : 'Created on';
    label_neededBy = appCtx.bioradResources.Needed_By ? appCtx.bioradResources.Needed_By : 'Needed by';
    label_status = appCtx.bioradResources.Status_col_Header ? appCtx.bioradResources.Status_col_Header : 'Status';
    label_comments = appCtx.bioradResources.Comments ? appCtx.bioradResources.Comments : 'Comments';
    label_acctNo = appCtx.bioradResources.Account_Number ? appCtx.bioradResources.Account_Number : 'Account number';
    label_pPlan = appCtx.bioradResources.Purchase_Plan ? appCtx.bioradResources.Purchase_Plan : 'Purchase plan';
    label_email = appCtx.bioradResources.EmailAdd ? appCtx.bioradResources.EmailAdd : 'Email address';
    label_purposeOfQuote = appCtx.bioradResources.Purpose_Of_Quote ? appCtx.bioradResources.Purpose_Of_Quote : 'Purpose of quote';
    label_grantApp = appCtx.bioradResources.Grant_Application ? appCtx.bioradResources.Grant_Application : 'Grant application';
    label_newLab = appCtx.bioradResources.New_Lab ? appCtx.bioradResources.New_Lab : 'New lab';
    label_salesRep = appCtx.bioradResources.Sales_Representative ? appCtx.bioradResources.Sales_Representative : 'Sales representative';
    label_pp_immediately= appCtx.bioradResources.PP_Immediately ? appCtx.bioradResources.PP_Immediately : "Immediately";
    label_pp_1_3_months= appCtx.bioradResources.PP_1_3_Months ? appCtx.bioradResources.PP_1_3_Months : "1 to 3 months";
    label_pp_6_months= appCtx.bioradResources.PP_6_Months ? appCtx.bioradResources.PP_6_Months : "6 months";
    label_pp_more_than_6_months= appCtx.bioradResources.PP_More_Than_6_Months ? appCtx.bioradResources.PP_More_Than_6_Months : "More than 6 months";
    label_fetch_error = appCtx.bioradResources["bad-request"] ? appCtx.bioradResources["bad-request"] : 'Sorry, we are experiencing issues. Please try again later.';
    label_seeMore = appCtx.bioradResources.See_More ? appCtx.bioradResources.See_More : "See more";
  }

  const getFileNameFromContentDispostionHeader = (header, defaultFileName) => {
    let contentDispostion = header.split(';');
    const fileNameToken = 'filename=';

    let fileName = defaultFileName;
    for (let thisValue of contentDispostion) {
        if (thisValue.trim().indexOf(fileNameToken) === 0) {
            fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''));
            break;
        }
    }

    return fileName;
  }

  const downloadPDFHandler = useCallback(async () => {
    setIsLoading(true);
    const getPDFURL = '/quoteservices/rfqs/pdf/' + quote.webReference + '/' + quote.quotePDFName;
    const response = await fetch(getPDFURL, { method: 'GET'} );

    if (!response.ok) {
      let errorMsg = label_fetch_error;
      const data = await response.json();
      if(data && data.status === 'fail'){
        errorMsg = data.message;
      }
      setIsAPIError(true);
      setErrorMsg(errorMsg);
      setIsLoading(false);

    }else{
      /*const data = await response.json();
      if(data && data.status === 'fail'){
        setIsAPIError(true);
        setErrorMsg(data.message);
      }else{

      }*/
      const fileName = getFileNameFromContentDispostionHeader(response.headers.get('content-disposition'), quote.quotePDFName);
      response.blob().then(blob => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = fileName;
        alink.click();
    })
      setIsLoading(false);
    }
    setIsLoading(false);
  },[]);

  SetAnalyticsData();

  let purchasePlanText = label_pp_immediately;
  if(quote?.purchasePlan){
    if(quote.purchasePlan === 'PP_1_3_Months'){
      purchasePlanText = label_pp_1_3_months;
    }else if(quote.purchasePlan === 'PP_6_Months'){
      purchasePlanText = label_pp_6_months;
    }else if(quote.purchasePlan === 'PP_More_Than_6_Months'){
      purchasePlanText = label_pp_more_than_6_months;
    }
  }

  const helpCenterLink =  appCtx?.envProp?.webServer + "help-center/quote-inquiries";

  return (
    <>
      <h2 className={styles.headingTitle}>
        {quote.quoteId ? (<>{label_quoteId}<br />{quote.quoteId}</>) 
        : (<>{label_WebRef}<br />{quote.webReference}</>)}
      </h2>
      <div className={styles.container}>
      <div className={styles.contact}>
        {quote?.quotePDFName?.trim() && <div onClick={downloadPDFHandler} className={styles.download} href="/download.pdf"><Download height={15} width={15}/> {label_downloadPDF}</div>}
        <a
          className={styles.contactInfo}
          href={helpCenterLink}
        >
          <HelpCircle height={15} width={15}/> {label_contactInfo}
        </a>
      </div>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tableHeader}>
            <th className={styles.col1}>{label_createdOn}</th>
            <th className={styles.col1}>{label_neededBy}</th>
            <th className={styles.col2}>{label_status}</th>
            <th className={styles.col3}>{label_comments}</th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tableRow}>
            <td className={styles.col1}>{quote.formattedDateQuoteRequested?quote.formattedDateQuoteRequested:''}</td>
            <td className={styles.col1}>{quote.formattedDateQuoteNeeded?quote.formattedDateQuoteNeeded:''}</td>
            <td className={styles.col2}><span className={`${styles.status} ${styles[quote.quoteStatus?.toLowerCase().replace(/ /g, '')]}`}>{quote.quoteStatus}</span></td>
            <td className={styles.col3}>
              <div ref={commentRef}
                className={`${styles.comment} ${expanded ? styles.expanded : ""}`}
              >{quote.comments || ""}
              </div>
              {!expanded && shouldShowSeeMore && (
                <div className={styles.seeMore} onClick={() => setExpanded(true)}>
                  {label_seeMore}
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
      {isAPIError && <p>{errorMsg}</p>}

      <div className={styles.infoGrid}>
        <div className={styles.card}>
          <div className={styles.label}><strong>{label_acctNo}</strong></div>
          <div>{quote.soldToAccountNumber?quote.soldToAccountNumber:''} </div>
        </div>
        <div className={styles.card}>
          <div className={styles.label}><strong>{label_pPlan}</strong></div>
          <div>{quote.purchasePlan?purchasePlanText:''}</div>
        </div>
        <div className={styles.card}>
          <div className={styles.label}><strong>{label_email}</strong></div>
          <div className={styles.ellipsis}>{quote.userEmail?quote.userEmail:''}</div>
        </div>
        <div className={styles.card}>
          <div className={styles.label}><strong>{label_salesRep}</strong></div>
          <div className={styles.salesRep}>
            {quote.salesRepName && quote.salesRepEmail && (
              <a href={'mailto:' + quote.salesRepEmail}>{quote.salesRepName}</a> )}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.label}><strong>{label_purposeOfQuote}</strong></div>
            {quote.isGrantApplication && <div>{label_grantApp}</div>}
            {quote.isNewLab && <div>{label_newLab}</div>}
          </div>
      </div>
    </div>
    </>
  );
};

export default QuoteDetailsHeaderNewBrand;